import { render, staticRenderFns } from "./selecteduser.vue?vue&type=template&id=a954c7b2&"
import script from "./selecteduser.vue?vue&type=script&lang=js&"
export * from "./selecteduser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports